// src/GlobalFonts.tsx

import React from 'react';
import { GlobalStyles } from '@mui/material';

const GlobalFonts = () => (
    <GlobalStyles
        styles={`
      @font-face {
        font-family: 'Kan-Black';
        src: local('SimplerPro_V3-Black'), url('../../../assets/fonts/SimplerPro_V3-Black.ttf') format('truetype');
      }
      @font-face {
        font-family: 'Kan-Regular';
        src: local('SimplerPro_V3-Regular'), url('../../../assets/fonts/SimplerPro_V3-Regular.ttf') format('truetype');
      }
      @font-face {
        font-family: 'Kan-Light';
        src: local('SimplerPro_V3-Light'), url('../../../assets/fonts/SimplerPro_V3-Light.ttf') format('truetype');
      }
      @font-face {
        font-family: 'Kan-Bold';
        src: local('SimplerPro_V3-Bold'), url('../../../assets/fonts/SimplerPro_V3-Bold.ttf') format('truetype');
      }
      @font-face {
        font-family: 'Kan-SemiBold';
        src: local('SimplerPro_V2-semibold'), url('../../../assets/fonts/SimplerPro_V2-semibold.otf') format('opentype');
      }
    `}
    />
);

export default GlobalFonts;
